<template>
  <div v-if="false && temp.length" class="-mx-2.5 -my-4">
    <ClientOnly>
      <div>
        <Swiper @swiper="onSwiper">
          <NuxtLink
            v-for="(card, index) in temp"
            :key="`${card.id}_${index}`"
            :to="`/teacher/${$route.params.parent}/${$route.params.category}/${card.slug}`"
            class="swiper-slide px-2.5 py-4"
          >
            <SwiperSlide>
              <MainPageCardsReworkedTeacherContentCard
                :data="card"
                :category-title="'highlight.title'"
                disable-announce
              />
            </SwiperSlide>
          </NuxtLink>
        </Swiper>
      </div>
    </ClientOnly>
    <!-- 
    <slider-control
      type="prev"
      class="hidden md:block absolute top-45% left-[-16px] z-10"
      :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
      @click.native="handleControlClick('prev')"
    />
    <slider-control
      type="next"
      class="hidden md:block absolute top-45% right-[-16px] z-10"
      :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
      @click.native="handleControlClick('next')"
    /> -->
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';
const { onSwiper } = useSwiper();
</script>

<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
  @apply hidden lg:block;
}
</style>
